import * as Sentry from '@sentry/react';

import { info } from 'src/services/logger';
import { ENVIRONMENT } from 'src/settings';

/**
 * Google Tag Manager custom event name. The Google Ads conversion tag in the
 * GTM container (GTM-N6RZGX6K) triggers on this exact string, so renaming it
 * requires updating the GTM trigger in the same release.
 */
export const SIGNUP_CONVERSION_EVENT = 'signup_conversion';

type DataLayerWindow = Window & { dataLayer?: Record<string, unknown>[] };

/**
 * Pushes the signup conversion event to the GTM dataLayer.
 *
 * Should be called exactly once when the user lands on /register/thank-you.
 * No-ops outside production so preview and local builds don't pollute conversion data.
 * The Google Ads conversion ID, label, and value are configured in GTM, not here.
 */
export function trackSignupConversion(): void {
  if (ENVIRONMENT !== 'production') return;

  try {
    const dataLayerWindow = window as DataLayerWindow;

    dataLayerWindow.dataLayer = dataLayerWindow.dataLayer || [];
    dataLayerWindow.dataLayer.push({ event: SIGNUP_CONVERSION_EVENT });
    info('[GoogleAds] signup conversion event pushed to dataLayer');
  } catch (error) {
    Sentry.captureMessage('GoogleAds.trackSignupConversion: event failed', {
      level: 'warning',
      extra: { error }
    });
  }
}
